import {ThunkDispatch, UnknownAction} from '@reduxjs/toolkit';

import {omneticApi} from '../baseApi/omneticApi';
import {RELATED_CUSTOM_NOTICES_TAG} from '../constants/RELATED_CUSTOM_NOTICES_TAG';

interface MutationLifecycleApi {
  dispatch: ThunkDispatch<unknown, unknown, UnknownAction>;
  queryFulfilled: PromiseLike<unknown>;
}

/**
 * `invalidatesTags` only reaches the api instance the endpoint is defined on, so a mutation on
 * another instance (metadaApi and friends) has to dispatch the invalidation into `omneticApi`
 * itself once the request succeeds.
 */
export const invalidateRelatedCustomNoticesOnSuccess = async (
  _queryArg: unknown,
  api: MutationLifecycleApi
) => {
  try {
    await api.queryFulfilled;
    api.dispatch(omneticApi.util.invalidateTags([RELATED_CUSTOM_NOTICES_TAG]));
  } catch {
    // The relation was not changed, so the related custom notices stay valid.
  }
};
